export default () => [
  {
    key: "status.name",
    name: i18n.app.common.status
  },
  {
    key: "contract_number",
    name: i18n.app.components.contract.contract_number
  },
  {
    key: "order_number",
    name: i18n.app.components.contract.order_number
  },
  {
    key: "depot.name",
    name: i18n.app.components.contract.depot
  },
  {
    key: "client.company.name",
    name: i18n.app.components.contract.client
  },
  {
    key: "leaseCompany.company.name",
    name: i18n.app.components.contract.lease_company
  },
  {
    key: "credit_type",
    name: i18n.app.components.contract.credit_type
  },
  {
    key: "vehicle.segment.name",
    name: i18n.app.components.contract.segment
  },
  {
    key: "vehicle.license_plate_formatted",
    name: i18n.app.components.contract.license_plate
  },
  {
    key: "vehicle.display_name",
    name: i18n.app.components.contract.replacement_vehicle
  },
  {
    key: "vehicle.model.brand.name",
    name: i18n.database.table.vehicles.columns.vehicle_brand_id
  },
  {
    key: "vehicle.model.name",
    name: i18n.database.table.vehicles.columns.vehicle_model_id
  },
  {
    key: "conkedOutVehicle.display_name",
    name: i18n.app.components.contract.conked_out_vehicle
  },
  {
    key: "conkedOutVehicle.mobility_package",
    name: i18n.database.table.contracts.conked_out_vehicle.mobility_package
  },
  {
    key: "conkedOutVehicle.license_plate_formatted",
    name: i18n.app.components.contract.conked_out_license_plate
  },
  {
    key: "conkedOutVehicle.segment_name",
    name: i18n.app.components.contract.company_vehicle_segment
  },
  {
    key: "location_type_drop_off",
    name: i18n.database.table.contracts.columns.location_type_drop_off
  },
  {
    key: "start_datetime",
    name: i18n.app.components.contract.start_datetime
  },
  {
    key: "duration_in_days",
    name: i18n.app.components.contract.duration_in_days
  },
  {
    key: "end_datetime",
    name: i18n.app.components.contract.end_datetime
  },
  {
    key: "signed_off_at",
    name: i18n.app.components.contract.signed_off_at
  },
  {
    key: "num_of_days_actual",
    name: i18n.app.components.contract.num_of_days_actual
  },
  {
    key: "created_at",
    name: i18n.app.components.contract.created_at
  }
];
